import { createContext, Dispatch, SetStateAction } from 'react';

type SelectedProductContext = {
  selectedProductId: string;
  setSelectedProductId: Dispatch<SetStateAction<string>>;
};

export const SelectedProductContext = createContext<SelectedProductContext>({
  selectedProductId: '',
  setSelectedProductId: () => {},
});
